/**
 * mailshotSent: has this mailshot been SENT?
 *
 * ⚠️ ONE FILE, SHARED BY SERVER AND BROWSER, as models/mailability.js is: `functions/models`
 * is a symlink to `src/models`, so the functions `require()` this exact file.
 *
 * WHY IT EXISTS (Oct 2026). The question was answered two ways. The check before an add, which
 * decides which homes are held back as "already in a mailshot that has been sent", called a
 * mailshot sent when it had a `mailedOutAt` or a `status` of "mailed". The pages (the home's
 * own page, the import's page, the "Mailed Out" badge in the add box itself) also took
 * `mailedOut` alone. So a mailshot marked `mailedOut: true` with no `mailedOutAt` was shown as
 * mailed everywhere and was NOT sent to the check: its homes were added with no box (the
 * second reviewer's S1 on PR #124). The marking writes the two together, so today's code
 * cannot make such a record; an older record or a hand edit could.
 *
 * THE RULE: any ONE of the three says sent. It errs towards "sent", which is the safe side:
 * a home held back can be let through by a person; a second letter cannot be taken back.
 * So the flag or the day held as TEXT is "sent" whatever the text says, the text "false"
 * included: only a plain no (false, 0, empty text, null, nothing) is "not marked". The app
 * writes a real true and a real date; text could only come from a hand edit or a script.
 *
 * ⚠️ "Sent" is not "marked as mailed" for the TAKING BACK of a marking
 * (`isMarkedAsMailed`, functions/operations/mailshotOperations.js), which goes by the two
 * fields the marking itself writes and is not this question.
 *
 * Pure: reads the three fields of what it is handed.
 */

/** The fields this rule reads. A function that fetches chosen fields of a mailshot fetches every one of these. */
export const SENT_FIELDS = Object.freeze(["mailedOut", "mailedOutAt", "status"]);

/** Has this mailshot been sent? `mailshot` is its record, or just these three fields of it. */
export function isMailshotSent(mailshot) {
  const m = mailshot !== null && typeof mailshot === "object" ? mailshot : {};
  return Boolean(m.mailedOut) || Boolean(m.mailedOutAt) || m.status === "mailed";
}
